<template>
  <div class="has-footer-payments">
    <NavBar class="overflow-y-hidden"/>
    <v-main class="overflow-hidden">
      <div v-if="isDateLoaded" class="row">
        <div class="col-12 col-md-10 col-lg-6 mx-auto pt-0">
          <div v-if="!hasData" class="col-12  text-center">
            <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
            <div class="mt-2">
              {{ currentBagResult }}
            </div>

          </div>
          <v-stepper v-else-if="!isPay" v-model="cartStepper">
            <v-stepper-header class="d-flex">
              <v-stepper-step
                  :complete="cartStepper > 1"
                  step="1">
                فاکتور خرید
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step
                  :complete="cartStepper > 2"
                  step="2">
                آدرس
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3">
                پرداخت
              </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content class="pt-0" step="1">
                <div class="row">
                  <div v-for="(vendor,i) in cartDataList" :key="i" class="col-12  pt-1">
                    <div class="bg-white p-2 py-0 rounded-lg">
                      <div class="row">
                        <router-link :to="{path:'StoreProfile',query:{VendorID:vendor[0].VendorID}}"
                                     class="col-12 py-1 d-inline-block">
                          <v-avatar>
                            <img :src="$replaceHttps(vendor[0].VendorLogo)" alt="لوگو فروشگاه">
                          </v-avatar>
                          <span class="font-weight-bold mr-1">فروشنده: </span><span>{{ vendor[0].VendorName }} <i v-if="vendor[0].IsVerified" class="fa-solid fa-badge-check mr-1"></i></span>
                        </router-link>
                        <div v-for="(item,i) in vendor" :key="i" class="col-12">
                          <div class="row mx-1">
                            <router-link :to="{name:'ProductDetail',query:{VendorProductID:item.VendorProductID}}"
                                         class="col-4 p-0 ">
                              <v-img :src="$replaceHttps(item.FileUrl)"
                                     :lazy-src="$replaceHttps(item.FileUrl)"
                                     class="rounded-lg"></v-img>
                            </router-link>
                            <div class="col-8 pl-1">
                              <div class="text-truncate  font-weight-bold">{{ item.Name }}</div>
                              <div class="row align-items-center">
                                <div class="col-4 font13px"> واحد:
                                </div>
                                {{ vendor[0].ProductUnit.Name }}
                                <div class="col-8 ">
                                  <div class="d-flex justify-content-end">
                                    <div v-if="item.Discount !== 0" class="product-card-discount rounded-circle m-0">
                                      {{ item.Discount }} %
                                    </div>
                                    <div class="text-decoration-line-through third-text font12px mr-3">
                                      {{ $numberWithCommas(item.Price) }}
                                    </div>
                                  </div>
                                </div>
                                <div class="text-left col-12 pt-0">
                                  <span>{{ $computingPriceOffer(item.Price, item.Discount) }}</span> تومان
                                </div>
                                <div class="col-12 col-md-10 col-lg-8 pt-0 mr-auto pl-1">
                                  <v-text-field
                                      v-model="item.NumberNeed"
                                      append-icon="fa-solid fa-minus"
                                      append-outer-icon="fa-light fa-trash-can"
                                      class="rounded-lg px-0 order-input-field "
                                      dense
                                      flat
                                      hide-details
                                      prepend-icon="fa-solid fa-cart-circle-plus"
                                      prepend-inner-icon="fa-solid fa-plus "
                                      solo
                                      @click:prepend="setOrder(item.VendorProductTipID,item.NumberNeed)"
                                      @click:append-outer="removeOrder(item.VendorProductTipID)"
                                      @click:append="minusOrder(item.VendorProductTipID)"
                                      @click:prepend-inner="addOrder(item.VendorProductTipID)"
                                  ></v-text-field>

                                </div>
                              </div>
                            </div>
                            <div class="col-12 light-gray-border-bottom">
                              <span class="d-inline-block w-25">جمع کل</span>
                              <span class="d-inline-block w-75 text-left">{{
                                  $numberWithCommas(item.TotalRow)
                                }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 font13px d-flex align-items-center justify-space-between">
                          <span class="font13px ml-4"> ثبت کد تخفیف این فروشگاه</span>
                          <div class="w-50 d-flex">
                            <v-text-field
                                v-model="cartDataList.discountCode"
                                class="rounded-lg px-0 cart-input "
                                dense
                                flat
                                hide-details
                                prepend-inner-icon="fa-solid fa-period "
                                solo>

                            </v-text-field>
                            <v-btn class="rounded-l-lg rounded-r-0" color="primary" depressed
                                   @click="setDiscountCode(vendor[0].VendorID,cartDataList.discountCode)">
                              ثبت
                            </v-btn>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="font13px">زمان تحویل را تعیین کنید</div>
                          <div v-if=" showTime" :id="vendor[0].VendorID" class="row" dir="ltr">
                            <carousel
                                :autoplay="false"
                                :autoplayTimeout="10000"
                                :dots="false"
                                :margin="2"
                                :nav="false"
                                :responsive="{0:{items:3},600:{items:7},992:{items:5}
                                                ,1250:{items:7}}"
                                class="col-12">
                              <div v-for="item in vendor.deliverTime" :key="item.id" class="row mx-1 no-gutters">
                                <div
                                    class="text-center cart-date-select col-12 d-flex flex-column justify-content-center"
                                    @click="changeColor($event,item.text,vendor[0].VendorID,i)">
                                  <div> {{ item.text }}</div>
                                  <div>{{ item.day }}</div>
                                </div>
                              </div>
                            </carousel>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="mt-2"><span class="d-inline-block w-50 font13px">
                        جمع کل این فروشگاه
                      </span><span
                              class="d-inline-block w-50 text-left font13px">
                        {{ $numberWithCommas(vendor[0].TotalVendorFactorAmount) }}
                      </span></div>
                          <div class="mt-2"><span class="d-inline-block w-50 font13px">
                        هزینه ارسال
                      </span>
                            <span
                                v-if="vendor[0].TotalVendorSendAmount !== 0"
                                class="d-inline-block w-50 text-left font13pxt">
                        {{ $numberWithCommas(vendor[0].TotalVendorSendAmount) }}                      </span>
                            <span
                                v-else
                                class="d-inline-block w-50 text-left font13pxt">
                      رایگان                     </span>
                          </div>
                          <div class="mt-2"><span class="d-inline-block w-50 font13px">
                        نوع ماشین
                      </span><span
                              class="d-inline-block w-50 text-left font13px">
                        {{ $TypeVehicleSend(vendor[0].HowVendorTypeVechileSend) }}
                      </span></div>
                          <div class="mt-2"><span class="d-inline-block w-50 font13px"> جمع قابل پرداخت</span><span
                              class="d-inline-block w-50 text-left font13px">
                        {{ $numberWithCommas(vendor[0].TotalVendorTotalAmount) }}
                      </span></div>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
                <div class="row">
                  <div class="col-12 bg-white rounded-t-lg fix-to-bottom p-md-5">
                    <div><span class="d-inline-block w-50">جمع کل فروشگاه ها </span><span
                        class="d-inline-block text-left w-50">{{ $numberWithCommas(cartData.FactorAmount) }}</span>
                    </div>
                    <div class="my-3"><span class="d-inline-block w-50">جمع هزینه ارسال</span><span
                        class="d-inline-block text-left w-50">{{ $numberWithCommas(cartData.SendAmount) }}</span></div>
                    <div><span class="d-inline-block w-50">جمع قابل پرداخت</span><span
                        class="d-inline-block text-left w-50 red--text">{{
                        $numberWithCommas(cartData.TotalAmount)
                      }}</span></div>
                    <div class="mt-2 text-center">
                      <v-btn color="primary" small @click="checkTimeSelected">پرداخت / ثبت سفارش</v-btn>
                    </div>
                  </div>
                </div>

              </v-stepper-content>

              <v-stepper-content class="pt-0" step="2">
                <div class="row">
                  <div class="col-12  pt-0">
                    <v-btn icon @click="cartStepper =1">
                      <i class="fa-solid fa-arrow-right fa-xl pointer"></i></v-btn>
                  </div>
                  <div class="col-12">
                    <div class="bg-white rounded-lg p-2">
                      <div class="font13px">آدرس گیرنده</div>
                      <v-btn class="pr-1 mt-2" text to="BuyerProfileSetting"><i
                          class="fas fa-pen-to-square fa-xl ml-1"></i> ویرایش
                      </v-btn>
                      <div class="pr-2 mt-2">
                        {{ province }}، {{ city }} ،
                        <span v-html="addressInfo.Address"></span> ،
                        واحد:{{ addressInfo.Vahed }}، پلاک: {{ addressInfo.Plak }} ،
                        کدپستی:
                        {{ addressInfo.ZipCode }}

                      </div>

                    </div>
                  </div>
                  <div class="col-12 bg-white rounded-t-lg fix-to-bottom p-md-5">
                    <div><span class="d-inline-block w-50">جمع کل فروشگاه ها </span><span
                        class="d-inline-block text-left w-50">{{ $numberWithCommas(cartData.FactorAmount) }}</span>
                    </div>
                    <div class="my-3"><span class="d-inline-block w-50">جمع هزینه ارسال</span><span
                        class="d-inline-block text-left w-50">{{ $numberWithCommas(cartData.SendAmount) }}</span></div>
                    <div><span class="d-inline-block w-50">جمع قابل پرداخت</span><span
                        class="d-inline-block text-left w-50 red--text">{{
                        $numberWithCommas(cartData.TotalAmount)
                      }}</span></div>
                    <div class="mt-2 text-center">
                      <v-btn color="primary" small @click="setDeliveryAddress">تایید آدرس و مرحله بعد</v-btn>
                    </div>
                  </div>
                </div>
              </v-stepper-content>
              <v-stepper-content class="pt-0" step="3">
                <div class="row">
                  <div class="col-12  pt-0">
                    <v-btn icon @click="cartStepper =2">
                      <i class="fa-solid fa-arrow-right fa-xl pointer"></i></v-btn>
                  </div>
                  <div class="col-12">
                    <div class="bg-white rounded-lg p-2">
                      <div class="font13px">آیا فاکتورخود را جهت پرداخت تایید میکنید؟</div>
                    </div>
                  </div>
                  <div class="col-12 bg-white rounded-t-lg fix-to-bottom p-md-5">
                    <div><span class="d-inline-block w-50">جمع کل فروشگاه ها </span><span
                        class="d-inline-block text-left w-50">{{ $numberWithCommas(cartData.FactorAmount) }}</span>
                    </div>
                    <div class="my-3"><span class="d-inline-block w-50">جمع هزینه ارسال</span><span
                        class="d-inline-block text-left w-50">{{ $numberWithCommas(cartData.SendAmount) }}</span></div>
                    <div><span class="d-inline-block w-50">جمع قابل پرداخت</span><span
                        class="d-inline-block text-left w-50 red--text">{{
                        $numberWithCommas(cartData.TotalAmount)
                      }}</span></div>
                    <div class="mt-2 text-center">
                      <v-btn v-if="isOnlineVendor" color="primary" small @click="payOnline">پرداخت</v-btn>
                      <v-btn v-else color="primary" small @click="payOffline"> ثبت سفارش</v-btn>
                    </div>
                  </div>
                </div>

              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
          <div v-else>
            <div class="row mx-1">
              <div class="col-12">
                <div class="bg-white rounded-lg py-6 px-3 text-center">
                  <div class="font13px"><i class="fa-solid fa-shield-check fa-lg ml-1 green--text"></i>
                  <div v-html="successMessage">

                  </div>
                  </div>
<!--                  <div class=" my-5">
                    <span class="font16px border-bottom">124ca2321</span>
                  </div>-->
                  <div class="font12px">
                    برای اطلاع از روند سفارش خود به پروفایل کاربری خود مراجعه کنید
                  </div>
                  <div class="mt-4 text-right">
                    <span><i class="fas fa-user mr-5 fa-xl"></i></span>
                    <router-link class="blue--text text-decoration-underline mr-1" to="BuyerCart">پروفایل کاربری</router-link>
                  </div>
                </div>
              </div>
            </div>
<!--            <div class="row mx-1">
              <div class="col-12">
                <div class="bg-white rounded-lg py-6 px-3 text-center">
                  <div class="font13px"><i class="fa-solid fa-face-frown fa-lg ml-1 red&#45;&#45;text"></i>خرید شما با موفقیت
                    ثبت نشد لطفا مجدد تلاش کنید
                  </div>
                  <div class="mt-4">
                    <span class="blue&#45;&#45;text text-decoration-underline mr-1"
                          @click="isPay = false">بازگشت به سبد خرید</span><span><i
                      class="fas fa-reply mr-5 fa-xl"></i></span>

                  </div>
                </div>
              </div>
            </div>-->
          </div>
        </div>
      </div>

    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import carousel from "vue-owl-carousel";

export default {
  name: "Cart",
  metaInfo: {
    title: 'ایوان خانه- سبدخرید',
  },
  components: {NavBar, carousel},
  data: () => ({
    isDateLoaded: false,
    showLoaderDialog: false,
    showResult: false,
    resultText: '',
    cartStepper: 1,
    isPay: false,
    showTime: false,
    cartData: [],
    deliverTime: [
      {day: '1401/01/01', text: 'شنبه'},
      {day: '1401/01/02', text: 'یکشنبه'},
      {day: '1401/01/03', text: 'دوشنبه'},
      {day: '1401/01/04', text: ' سه شنبه'},
      {day: '1401/01/05', text: ' چهار شنبه'},
      {day: '1401/01/06', text: ' پنج شنبه'},
      {day: '1401/01/07', text: 'جمعه'},
    ],
    dayOfWeek: ['یکشنبه', 'دوشنبه', 'سه شنبه', 'چهار شنبه', 'پنج شنبه', 'جمعه', 'شنبه'],
    cartDataList: [],
    stores: [],
    addressInfo: {},
    city: null,
    province: null,
    isOnlineVendor: null,
    addressID: null,
    currentBagResult: null,
    hasData: false,
    vendors: [],
    selectedTime: {},
    successMessage:''

  }),
  mounted() {
    this.getData()
    this.getDeliveryAddress()
  },
  methods: {
    getData() {
      this.showTime = false
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/CurrentBag", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {

            this.$store.commit('addProductToCart')
            this.showLoaderDialog = false
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.hasData = true
              let cartData = json.ListShoppingView
              this.cartData = json
              this.getStoreDetail(cartData[0].VendorID)
              let resultJson = cartData.map(item => item.VendorID)
                  .filter((value, index, self) => self.indexOf(value) === index)
              for (let i = 0; i < resultJson.length; i++) {
                this.getStoreDetail(resultJson[i])
              }
              let resArr = []

              for (let i = 0; i < resultJson.length; i++) {
                resArr.push(cartData.filter(x => x.VendorID === resultJson[i]))
                resArr.discountCode = null
              }
              for (let i = 0; i < resArr.length; i++) {
                let sendDay = []
                for (let j = 0; j < resArr[i].length; j++) {
                  sendDay.push(resArr[i][j].DayDeliver)
                }
                let maxDeliverDay = Math.max(...sendDay)

                let date = new Date()

                date.setDate(date.getDate() + maxDeliverDay);
                let timeItems = [];
                for (let i = 0; i < 7; i++) {
                  date.setDate(date.getDate() + 1)
                  timeItems.push({
                    id: date.toISOString(),
                    text: this.$convertDate(date.toISOString()),
                    day: this.dayOfWeek[this.$dayOfWeek(date.toISOString())]
                  })
                }

                resArr[i].deliverTime = timeItems
                resArr[i].deliverDate = null
              }
              this.cartDataList = resArr
              this.showTime = true
            } else {
              this.hasData = false

              this.currentBagResult = result
            }

            this.isDateLoaded = true
          })
          .catch(error => console.log('error', error));

    },
    getStoreDetail(id) {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchEngine/SpecialVendor?VendorID=" + id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let isOnline = json.VendorViewModel.IsOnlineVendor
            this.isOnlineVendor = !!isOnline;

          })
          .catch(error => console.log('error', error));
    },
    removeOrder(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/RemoveOrder", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.resultText = json.Message
              this.getData()
            } else {
              this.resultText = result
            }
            this.showLoaderDialog = false
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    minusOrder(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/MinusOrder", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.resultText = json.Message
              this.getData()
            } else {
              this.resultText = result
            }
            this.showLoaderDialog = false
            this.showResult = true
          })
          .catch(error => console.log('error', error));

    },
    addOrder(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ID", id);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/AddOrder", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.resultText = json.Message
              this.getData()
            } else {
              this.resultText = result
            }
            this.showLoaderDialog = false
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    setOrder(id, numberNeed) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ID", id);
      urlencoded.append("NumberNeed", numberNeed);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/SetOrder", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.resultText = json.Message
              this.getData()
            } else {
              this.resultText = result
            }
            this.showLoaderDialog = false
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },
    setDiscountCode(id, code) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorID", id);
      urlencoded.append("CodeNumber", code);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/ValidateCode", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {

            if (resStatus === 200) {
              this.getData()
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    changeColor(e, date, id, i) {
      this.showLoaderDialog = true
      let vendorContainer = document.getElementById(id);
      let tabs = vendorContainer.getElementsByClassName("cart-date-select-change-color");
      for (let i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove("cart-date-select-change-color")
      }
      e.target.parentNode.classList.add('cart-date-select-change-color')

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorID", id);
      urlencoded.append("DayDeliver", this.$convertDateToMiladi(date));


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Shopping/SetDayDeliver", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.selectedTime[i] = true
          })
          .catch(error => console.log('error', error));

    },
    getDeliveryAddress() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/Individual/_IndividualDelivery", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.addressID = json.DeliveryAddressID
            this.addressInfo = json
            let provinceId = json.ProvinceID;
            let cityId = json.CityID;
            let provinces = json.Provinces;
            this.province = provinces.find(x => x.Value === provinceId).Text
            let cities = json.Cities
            this.city = cities.find(x => x.Value === cityId).Text

          })
          .catch(error => console.log('error', error));
    },
    setDeliveryAddress() {
      this.showLoaderDialog = true
      if(this.province !== null && this.city !== null && this.addressInfo.Address !== null) {
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        let urlencoded = new URLSearchParams();
        urlencoded.append("DeliveryAddressID", this.addressID);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };
        let resStatus = null
        fetch(this.$baseUrl + "Shopping/SetDeliveryAddress", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()

            })
            .then(result => {
              if (resStatus === 200) {

                this.cartStepper = 3
              }
              this.showLoaderDialog = false
              this.resultText = result
              this.showResult = true
            })
            .catch(error => console.log('error', error));
      }else {
        this.resultText = 'برای ادامه بایستی اطلاعات ارسال را در پروفایل خود تکمیل کنید'
        this.showResult = true
      }
    },
    payOnline() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/SetInvoice", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            console.log(result)
            console.log(resStatus)
            if (resStatus === 200) {
              this.$setAppState('totalCart')
              this.$openLink(result)
            } else {
              this.resultText = result
              this.showResult = true
            }
          })
          .catch(error => console.log('error', error));
    },
    payOffline() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Shopping/SetInvoice", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            console.log(result)
            this.showLoaderDialog = false
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.successMessage= json.Message
              this.isPay = true
              this.$store.commit('addProductToCart')
            } else {
              this.resultText = result
              this.showResult = true
            }
          })
          .catch(error => console.log('error', error));
    },
    checkTimeSelected() {
      let vendorNumber = this.cartDataList.length
      let canGoNextStep = false
      for (let i = 0; i < vendorNumber; i++) {
        canGoNextStep = this.selectedTime[i] !== undefined;
      }
      if (canGoNextStep) {
        this.cartStepper = 2
      } else {
        this.resultText = 'برای ادامه بایستی، برای تمام فروشگاه ها زمان تحویل انتخاب کنید'
        this.showResult = true
      }
    }

  }
}
</script>

<style scoped>

</style>
